import { useCheckInValue, useCheckOutValue, useSelectedRoomValue } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { createRandomString } from "@/utils";
import { Center } from "@chakra-ui/react";
import { CustomButton, CustomCenter, CustomText } from "./bookBar.style";
import { useBookParameter } from "./hooks";

export const BookBar = () => {
    const checkIn = useCheckInValue();
    const checkOut = useCheckOutValue();
    const selectedRooms = useSelectedRoomValue();
    const { mutate } = useBookParameter();

    // 선택한 객체 배열 중 필요한 값들만 파싱
    const roomIdxGroup = selectedRooms.map((room) => room.roomIdx).join("|");
    const adultGroup = selectedRooms.map((room) => room.person?.adult).join("|");
    const childGroup = selectedRooms.map((room) => room.person?.child).join("|");
    const infantGroup = selectedRooms.map((room) => room.person?.infant).join("|");

    const finalBookPrice = selectedRooms.reduce((acc, cur) => acc + cur.newOffPrice, 0);
    const { isLaptop, isTablet } = MEDIA();
    const laptopPadding = isLaptop ? "0 44px" : "0 24px";

    const handleBookStart = () => {
        if (checkOut) {
            const uid = createRandomString(6);
            const params = {
                uid,
                checkInDate: checkIn,
                checkOutDate: checkOut,
                roomIdx: roomIdxGroup,
                adult: adultGroup,
                child: childGroup,
                infant: infantGroup,
                section: "booking",
                page: "reserve",
            };

            mutate(params);
        }
    };

    return (
        <CustomCenter position="sticky" bottom="0" w="100%">
            <Center
                w="100%"
                maxW="1400px"
                p={isTablet ? "0 20px" : laptopPadding}
                m="0 auto"
                justifyContent="flex-end"
                columnGap="24px"
            >
                <CustomText>
                    총 <span>{finalBookPrice.toLocaleString()}</span>원
                </CustomText>
                <CustomButton size="medium" disabled={finalBookPrice === 0} onClick={handleBookStart}>
                    예약하기
                </CustomButton>
            </Center>
        </CustomCenter>
    );
};
